import React from 'react';
import Icon from '../../../components/AppIcon';

const SetTracker = ({ 
  completedSets, 
  totalSets, 
  currentSet,
  setResults = [] 
}) => {
  const renderSetStatus = (setNumber) => {
    const isCompleted = setNumber < currentSet;
    const isCurrent = setNumber === currentSet;
    const setResult = setResults?.[setNumber - 1];

    let statusIcon = 'Circle';
    let statusColor = 'text-muted-foreground';
    let bgColor = 'bg-muted/30';

    if (isCompleted) {
      statusIcon = 'CheckCircle';
      statusColor = 'text-success';
      bgColor = 'bg-success/10';
    } else if (isCurrent) {
      statusIcon = 'Target';
      statusColor = 'text-primary';
      bgColor = 'bg-primary/10';
    }

    return (
      <div key={setNumber} className="flex flex-col items-center space-y-3">
        <div className={`w-20 h-20 rounded-full ${bgColor} flex items-center justify-center border-2 ${
          isCurrent ? 'border-primary animate-gentle-pulse' : 
          isCompleted ? 'border-success' : 'border-border'
        }`}>
          <Icon name={statusIcon} size={32} className={statusColor} />
        </div>
        <div className="text-center">
          <p className={`text-xl font-bold ${statusColor}`}>
            Set {setNumber}
          </p>
          {setResult && (
            <p className="text-lg text-muted-foreground">
              {setResult?.reps} reps
            </p>
          )}
        </div>
        {/* Connecting Line */}
        {setNumber < totalSets && (
          <div className={`w-1 h-12 ${
            setNumber < currentSet ? 'bg-success' : 'bg-border'
          } rounded-full`} />
        )}
      </div>
    );
  };

  return (
    <div className="bg-surface rounded-2xl p-8 shadow-lg border border-border">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-foreground mb-2">
          Set Progress
        </h2>
        <p className="text-xl text-muted-foreground">
          Track your completed sets
        </p>
      </div>

      {/* Set Progress Visual */}
      <div className="flex items-center justify-center space-x-8 mb-8">
        {Array.from({ length: totalSets }, (_, index) => 
          renderSetStatus(index + 1)
        )}
      </div>

      {/* Summary Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6 border-t border-border">
        <div className="text-center">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="CheckCircle" size={24} className="text-success" />
          </div>
          <p className="text-2xl font-bold text-foreground">{completedSets}</p>
          <p className="text-lg text-muted-foreground">Completed</p>
        </div>

        <div className="text-center">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Target" size={24} className="text-primary" />
          </div>
          <p className="text-2xl font-bold text-foreground">{currentSet}</p>
          <p className="text-lg text-muted-foreground">Current Set</p>
        </div>

        <div className="text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Circle" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-2xl font-bold text-foreground">{totalSets - currentSet}</p>
          <p className="text-lg text-muted-foreground">Remaining</p>
        </div>
      </div>
    </div>
  );
};

export default SetTracker;